import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const StyledCallButtonWrapper = styled.div`
  margin: ${spacing.space16} 0;
`;
